import { render, staticRenderFns } from "./RecordListItemTable.vue?vue&type=template&id=bf68a988&scoped=true&"
import script from "./RecordListItemTable.vue?vue&type=script&lang=ts&"
export * from "./RecordListItemTable.vue?vue&type=script&lang=ts&"
import style0 from "./RecordListItemTable.vue?vue&type=style&index=0&id=bf68a988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf68a988",
  null
  
)

export default component.exports